import api from '../../store/config/api';
import { schema } from 'normalizr'; // eslint-disable-line no-unused-vars
import { RUN as SCHEMA } from '../../schemas';

export const [
  GET_RUN,
  GET_RUN_REQUEST,
  GET_RUN_SUCCESS,
  GET_RUN_FAILURE
] = api.buildTypes('GET_RUN');

function runUrl(teamName, runID, withChildren) {
  let url = `/teams/${teamName}/runs/${runID}`;
  if (withChildren) {
    url += '?includeChildren=true&includeDownloadUrls=true';
  }
  return url;
}

export function getRun({ teamName, runID, withChildren = false }) {
  return {
    type: GET_RUN,
    payload: {
      url: runUrl(teamName, runID, withChildren),
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export function getRunProgress({ teamName, runID, progressSecret }) {
  return {
    type: GET_RUN,
    payload: {
      url: `teams/${teamName}/runs/${runID}/progress/${progressSecret}`,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  ADD_RUN,
  ADD_RUN_REQUEST,
  ADD_RUN_SUCCESS,
  ADD_RUN_FAILURE
] = api.buildTypes('ADD_RUN');

export function addRun({ teamName, data }) {
  return {
    type: ADD_RUN,
    payload: {
      url: `/teams/${teamName}/runs/`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: data
      }
    }
  };
}

export const [
  UPDATE_RUN,
  UPDATE_RUN_REQUEST,
  UPDATE_RUN_SUCCESS,
  UPDATE_RUN_FAILURE
] = api.buildTypes('UPDATE_RUN');

export const updateRun = ({
  teamName,
  runID,
  run = {},
  withChildren = false
}) => ({
  type: UPDATE_RUN,
  payload: {
    url: runUrl(teamName, runID, withChildren),
    schema: SCHEMA,
    options: {
      method: 'PUT',
      body: run
    }
  }
});



// WEBPACK FOOTER //
// ./js/actions/api/run.js